import { ListMinimal } from "common/styleguide/ListMinimal";
import React from "react";
import styles from "./FullBleedList.scss";

export const FullBleedList = ({ children, expanded, interactive, ...props }) => (
  <ListMinimal interactive={interactive} expanded={expanded} className={styles.FullBleedList} {...props}>
    {children}
  </ListMinimal>
);

// NOTE: FullBleedList currently doesn't properly handle interactive=false. in
// this case, ListMinimal no longer adds a background on hover, but
// FullBleedList will still change its margins, and thus cause the border-top
// and border-bottom to protrude into the gutter
FullBleedList.defaultProps = {
  interactive: true,
};
